import useTracking from '@common/src/hooks/tracking/useTracking';
import {
  ButtonGroup,
  IconButton,
  Icon,
  Flex,
  Tooltip,
} from '@wegroup/design-system';
import React from 'react';

interface Props {
  onAdd?: () => void;
  isAddDisabled?: boolean;
  onEdit?: () => void;
  isEditDisabled?: boolean;
  onRemove?: () => void;
  isRemoveDisabled?: boolean;
  undoTooltip?: string;
  onUndo?: () => void;
  isUndoDisabled?: boolean;
  eventName?: string;
}

const TableRowActions: React.FC<Props> = ({
  onEdit,
  isEditDisabled,
  onRemove,
  isRemoveDisabled,
  onAdd,
  isAddDisabled,
  onUndo,
  isUndoDisabled,
  undoTooltip,
  eventName,
}) => {
  const { trackEvent } = useTracking();

  const handleAdd = () => {
    if (eventName)
      trackEvent(`Add ${eventName} in advisory report creation flow`);
    onAdd?.();
  };

  const handleEdit = () => {
    if (eventName)
      trackEvent(`Edit ${eventName} in advisory report creation flow`);
    onEdit?.();
  };

  const handleRemove = () => {
    if (eventName)
      trackEvent(`Remove ${eventName} in advisory report creation flow`);
    onRemove?.();
  };

  const handleUndo = () => {
    if (eventName)
      trackEvent(`Undo ${eventName} in advisory report creation flow`);
    onUndo?.();
  };

  return (
    <Flex justifyContent="flex-end">
      <ButtonGroup variant="white" isAttached>
        {onUndo && (
          <Tooltip label={undoTooltip}>
            <IconButton
              size="sm"
              onClick={handleUndo}
              icon={<Icon name="GeneralActionsReset" boxSize={5} />}
              aria-label="Undo"
              isDisabled={isUndoDisabled}
            />
          </Tooltip>
        )}
        {onAdd && (
          <IconButton
            size="sm"
            aria-label="add"
            onClick={handleAdd}
            icon={<Icon boxSize={5} name="GeneralActionsAdd" />}
            isDisabled={isAddDisabled}
          />
        )}
        {onEdit && (
          <IconButton
            onClick={handleEdit}
            size="sm"
            icon={<Icon name="GeneralActionsEditDocument" boxSize={5} />}
            aria-label="Edit"
            isDisabled={isEditDisabled}
          />
        )}

        {onRemove && (
          <IconButton
            onClick={handleRemove}
            size="sm"
            icon={
              <Icon
                name="GeneralActionsThrash"
                boxSize={5}
                color={isRemoveDisabled ? 'gray.300' : 'danger.main'}
              />
            }
            aria-label="Remove"
            isDisabled={isRemoveDisabled}
          />
        )}
      </ButtonGroup>
    </Flex>
  );
};

export default TableRowActions;
